import request from "@/utils/request";  //导入封装请求的js文件

export function info(balanceId) {
    return request({
        url: "/memberApi/usageDetails/" + balanceId,  //接口路径
        method: "get",  //接口方法
    });
}
